import Logo from "../../../assets/img/logo.png";
import { useLocation, useNavigate } from "react-router-dom";
import SubscriptionContext from "../../../contexts/subscriptionContext";
import SubscriptionContextModel from "../../../contexts/subscriptionContextModel";
import { useContext } from "react";

const SideBar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { subscription } =
    useContext<SubscriptionContextModel>(SubscriptionContext);

  const onLogoClick = () => {
    navigate("/");
  };

  return (
    <>
      {/* <!-- Sidebar --> */}
      <aside className="sidebar">
        {/* <!-- Sidebar Header --> */}
        <div className="sidebar-header">
          <div
            className="sidebar-logo"
            style={{ cursor: "pointer" }}
            onClick={onLogoClick}
          >
            <img src={Logo} alt="Work Order Direct" />
            <span>Work Order Direct</span>
          </div>
          <button className="sidebar-close">
            <i className="bi bi-x-lg"></i>
          </button>
        </div>

        {/* <!-- Sidebar Navigation --> */}
        <nav className="sidebar-nav">
          <ul className="nav-menu">
            {/* <!-- Main Section --> */}
            {/* <!-- Note: Initail Sidebar Items look more slim - probably because there is styled the a element instead of div --> */}
            {/* <li className="nav-item">
              <a
                className="nav-link active"
                href="index.html"
                data-sidebar-tooltip="Dashboard"
              >
                <i className="ph-light ph-squares-four"></i>
                <span>Dashboard</span>
              </a>
            </li> */}
            <li className="nav-item">
              <div
                // className="nav-link active"
                className={
                  location.pathname === "/work" ? "nav-link active" : "nav-link"
                }
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/work")}
                data-sidebar-tooltip="Dashboard"
              >
                {/* <i className="ph-light ph-squares-four"></i> */}
                <i className="bi bi-grid"></i>
                <span>Dashboard</span>
              </div>
            </li>

            {/* <!-- Work Orders --> */}
            <li className="nav-item">
              <div
                className={
                  location.pathname.includes("/work/work-orders") ||
                  location.pathname.includes("/work/dispatches")
                    ? "nav-link active"
                    : "nav-link"
                }
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/work/work-orders")}
                data-sidebar-tooltip="Work Orders"
              >
                <i className="bx bxs-notepad"></i>
                <span>Work Orders</span>
              </div>
            </li>

            {subscription.canSeeAccounts && (
              <>
                {/* <!-- Accounts --> */}
                <li className="nav-item">
                  <div
                    className={
                      location.pathname === "/work/accounts"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/work/accounts")}
                    data-sidebar-tooltip="Accounts"
                  >
                    <i className="bx bxs-contact"></i>
                    <span>Accounts</span>
                  </div>
                </li>

                {/* <!-- Locations --> */}
                <li className="nav-item">
                  <div
                    className={
                      location.pathname === "/work/locations"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/work/locations")}
                    data-sidebar-tooltip="Locations"
                  >
                    <i className="bi bi-house-door-fill"></i>
                    <span>Locations</span>
                  </div>
                </li>
              </>
            )}

            {/* <!-- Service Providers --> */}
            <li className="nav-item">
              <div
                className={
                  location.pathname === "/work/service-providers"
                    ? "nav-link active"
                    : "nav-link"
                }
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/work/service-providers")}
                data-sidebar-tooltip="Service Providers"
              >
                <i className="bx bxs-briefcase"></i>
                <span>Service Providers</span>
              </div>
            </li>

            {/* <!-- Users --> */}
            <li className="nav-item">
              <div
                className={
                  location.pathname === "/work/users"
                    ? "nav-link active"
                    : "nav-link"
                }
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/work/users")}
                data-sidebar-tooltip="Users"
              >
                {/* <i className="bi bi-person-badge-fill"></i> */}
                <i className="ph-light ph-users"></i>
                <span>Users</span>
              </div>
            </li>

            {/* <!-- Portal Admin Section --> */}
            <li className="nav-heading">
              <span>Portal Admin</span>
            </li>

            {/* <!-- Trades --> */}
            <li className="nav-item">
              <div
                className={
                  location.pathname === "/work/trades"
                    ? "nav-link active"
                    : "nav-link"
                }
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/work/trades")}
                data-sidebar-tooltip="Trades"
              >
                <i className="bi bi-hammer"></i>
                <span>Trades</span>
              </div>
            </li>
          </ul>
        </nav>

        {/* <!-- Sidebar Footer --> */}
        {/* <div className="sidebar-footer">
          <div className="sidebar-footer-user">
            <a href="profile.html" className="sidebar-footer-profile">
              <img
                src="assets/img/profile-img.webp"
                alt="User"
                className="sidebar-footer-avatar"
              />
              <div className="sidebar-footer-info">
                <div className="sidebar-footer-name">John Doe</div>
                <div className="sidebar-footer-role">Administrator</div>
              </div>
            </a>
            <div className="sidebar-footer-actions">
              <a
                href="settings.html"
                className="sidebar-footer-action"
                title="Settings"
              >
                <i className="ph-light ph-gear"></i>
              </a>
              <a
                href="auth-login.html"
                className="sidebar-footer-action sidebar-footer-logout"
                title="Logout"
              >
                <i className="ph-light ph-sign-out"></i>
              </a>
            </div>
          </div>
        </div> */}
      </aside>

      {/* <!-- Sidebar Overlay (Mobile) --> */}
      <div className="sidebar-overlay"></div>
    </>
  );
};

export default SideBar;
